import { useEffect } from "react";

const ConfirmModal = ({
    open,
    onClose,
    onConfirm,
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    loading = false,
    variant = "danger", // "danger" | "primary"
}) => {
    // close on ESC
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };
        if (open) window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center">

            {/* BACKDROP */}
            <div
                onClick={onClose}
                className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            />

            {/* MODAL */}
            <div className="relative w-full max-w-md bg-[var(--card-bg)] border border-[var(--border-color)] rounded-xl p-6 shadow-xl">
                <button
                    type="button"
                    onClick={onClose}
                    disabled={loading}
                    className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-lg bg-[var(--bg-primary)] text-lg leading-none text-[var(--text-secondary)] hover:bg-[var(--accent-soft)] disabled:opacity-60"
                    aria-label="Close"
                >
                    x
                </button>

                {/* TITLE */}
                <h2 className="mb-2 pr-9 text-lg font-semibold">
                    {title}
                </h2>

                {/* MESSAGE */}
                <p className="text-sm text-gray-400 mb-6">
                    {message}
                </p>

                {/* ACTIONS */}
                <div className="flex justify-end gap-3">

                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="px-4 py-2 rounded-md bg-[var(--bg-primary)] hover:bg-[var(--accent-soft)] text-sm transition"
                    >
                        {cancelText}
                    </button>

                    <button
                        onClick={onConfirm}
                        disabled={loading}
                        className={`px-4 py-2 rounded-md text-sm font-medium transition ${variant === "danger"
                                ? "bg-red-500 hover:bg-red-600"
                                : "bg-emerald-500 hover:bg-emerald-600"
                            }`}
                    >
                        {loading ? "Processing..." : confirmText}
                    </button>

                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
